import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import devopsOne from "./assets/devops/devops_1.png";
import devopsTwo from "./assets/devops/devops_2.png";
import devopsThree from "./assets/devops/devops_3.png";
import devopsFour from "./assets/devops/devops_4.png";
import devopsFive from "./assets/devops/devops_5.png";

import bestPractise from "./assets/devops/best_practise.png";
import chooseUs from "./assets/devops/choose_us.png";
import coreComplete from "./assets/devops/core_complete.png";
import hightRoi from "./assets/devops/high_roi.png";
import lastestTech from "./assets/devops/latest_tech.png";
import provenExp from "./assets/devops/proven_exp.png";
import scalability from "./assets/devops/Scalability.png";
import toolSet from "./assets/devops/Tool_Set.png";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const DevopsDevelopment = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [devopsThree, devopsTwo, devopsFour, devopsFive];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${devopsOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              DevOps Solutions
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              DevOps Solutions
            </Typography>
            <Typography variant="body1" paragraph>
              DevOps solutions bridge the gap between development and
              operations, enabling faster and more reliable software delivery.
              Our DevOps services streamline workflows, automate deployment
              pipelines, and promote continuous integration and delivery
              (CI/CD). This means quicker releases, reduced errors, and more
              consistent performance for your applications.
            </Typography>

            <Typography variant="body1" paragraph>
              We help organizations embrace DevOps culture by aligning tools,
              teams, and processes. From infrastructure automation to monitoring
              and scaling, our solutions ensure your systems are resilient,
              secure, and ready to adapt to business needs. The result? Enhanced
              agility, reduced downtime, and improved collaboration across
              departments.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Benefits of Managed IT Solutions
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Managed IT solutions offer businesses round-the-clock monitoring,
              proactive issue resolution, and strategic guidance—all without the
              overhead of maintaining an internal IT team. Our managed services
              include network management, cloud infrastructure, security, data
              backups, and user support tailored to your business goals. With
              us, you can reduce operational risks and focus on scaling your
              business. We ensure your systems are always secure, up to date,
              and optimized for performance—allowing you to allocate resources
              more efficiently while gaining access to expert-level support when
              needed.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={hightRoi}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              High ROI
            </Typography>
            <Typography variant="body1">
              Investing in our DevOps and IT solutions delivers a high return on
              investment by cutting operational costs and increasing efficiency.
              By automating repetitive tasks and reducing time-to-market, we
              help you avoid delays and maximize the value of your technology
              investments. Our services also reduce the risk of downtime and
              security breaches—two factors that can heavily impact
              profitability. With improved system reliability and continuous
              delivery, your business can focus on innovation while keeping
              costs under control.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Scalability
            </Typography>
            <Typography variant="body1">
              Scalability is a core benefit of our solutions. Whether you're a
              startup expecting growth or an enterprise expanding globally, our
              DevOps and managed IT infrastructure adjusts seamlessly to your
              needs. You can scale up during peak times or scale down when
              demand decreases—without compromising performance. From
              cloud-native architectures to elastic computing environments, we
              design systems that grow with your business. This flexibility
              allows you to handle increased user loads, launch new features,
              and enter new markets without overhauling your entire tech stack.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={scalability}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={devopsFour}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Latest Technology
            </Typography>
            <Typography variant="body1">
              We leverage the latest technology and best-in-class tools to give
              your business a competitive edge. Our DevOps pipeline includes
              modern solutions for containerization, orchestration, monitoring,
              and version control—ensuring your development lifecycle is
              streamlined and secure. From cloud platforms like AWS, Azure, and
              Google Cloud to tools like Kubernetes, Docker, Terraform, and
              Jenkins, we ensure your business stays ahead of the tech curve.
              Adopting new technologies with us is risk-free, scalable, and
              strategically guided.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Proven Experts
            </Typography>
            <Typography variant="body1">
              Our team consists of certified DevOps engineers, cloud architects,
              and IT professionals with a track record of delivering results
              across industries. With hands-on experience in complex
              environments, we provide expert guidance at every stage of your
              digital transformation. We don't just implement solutions—we
              educate your team, optimize your workflows, and future-proof your
              operations. Our proven expertise ensures you make technology
              decisions that align with your business objectives and long-term
              vision.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={provenExp}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={chooseUs}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Why Choose Us?
            </Typography>
            <Typography variant="body1">
              Choosing us means you're partnering with a team that prioritizes
              reliability, innovation, and results. We take a consultative
              approach to understand your unique business needs and tailor
              DevOps and IT solutions that solve real problems—not just
              surface-level issues. Our commitment doesn’t end with
              implementation. We monitor, improve, and evolve your systems with
              industry best practices, so you’re always one step ahead. From
              small startups to large enterprises, businesses choose us for our
              transparency, expertise, and unwavering support.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Focus on Core Competency
            </Typography>
            <Typography variant="body1">
              Outsourcing your DevOps and IT management to us allows your
              internal team to focus on what matters most—your core business.
              Instead of worrying about uptime, server health, or deployment
              pipelines, you can concentrate on innovation, customer engagement,
              and growth. With our reliable backend support, your operations
              become more agile and less burdened by technical overhead. This
              not only improves productivity but also speeds up project
              timelines and helps your teams deliver better results.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={coreComplete}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={toolSet}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Our Tool Set
            </Typography>
            <Typography variant="body1">
              Our DevOps toolset is carefully curated for performance,
              reliability, and scalability. We use tools like GitLab, Jenkins,
              Docker, Kubernetes, Ansible, Terraform, Prometheus, and
              Grafana—providing end-to-end automation, monitoring, and
              infrastructure as code. These tools allow us to create a fully
              integrated CI/CD pipeline, manage configurations, monitor system
              health, and deploy across multiple cloud platforms with minimal
              downtime. Every tool we implement is chosen to fit your
              environment and business goals.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Best Practices
            </Typography>
            <Typography variant="body1">
              We adhere to industry-recognized best practices in everything we
              do—from secure coding standards to infrastructure automation. Our
              workflows are built around principles of agility, reliability, and
              transparency, ensuring predictable, repeatable outcomes every
              time. Whether it’s deploying a Kubernetes cluster or automating
              backups, we apply practices like infrastructure as code, version
              control, regular testing, and proactive monitoring. This
              guarantees system stability, faster recovery times, and minimal
              service disruptions.
            </Typography>
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={bestPractise}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default DevopsDevelopment;
